<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Send Welcome Email
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-cancel-warning">
        {{ bodyText }}
      </div>
      <ProcessOverlay
        :show="sendingEmail"
        text="Sending Email"
        overlayClass="ac-overlay"
      />
      <SACCheckbox
        label="Send email for web portal"
        class="mt-6"
        :checked="isPortal"
        :change="toggleIsPortal"
      />
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-cancel-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="sendWelcomeEmail(customer.email, isPortal)"
      >
        Send Email
      </button>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';

export default {
  name: 'SendWelcomeEmail',
  components: {
    SACCheckbox,
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      isPortal: false,
    };
  },
  computed: {
    bodyText() {
      if (this.actionModalView === 'welcome-email-again') {
        return 'Looks like you updated the member\'s email. Would you like to send a welcome email to the new email?';
      }
      return 'Are you sure you want to send an welcome email to the member?';
    },
  },
  methods: {
    toggleIsPortal() {
      this.isPortal = !this.isPortal;
    },
  },
};
</script>
